<template>
  <footer class="footer">
    <LayoutFooterFooterMain />
    <LayoutFooterFooterCopyright />
  </footer>
</template>

<style scoped>
.footer {
  width: 100%;
  margin-top: 64px;
}
</style>
